import state from './moduleAccountingState.js'
import mutations from './moduleAccountingMutations.js'
import actions from './moduleAccountingActions.js'
import getters from './moduleAccountingGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
